import React from 'react'
import Card from './Card'
import Location from './Location'
import Title from './Title'

const getItemKey = (activeView, item, index) => {
  if (activeView === 'cards') {
    const base = item.nameEN || item.name || item.imgUrl || 'card'
    return `card-${base}-${index}`
  }

  if (activeView === 'locations') {
    const base = item.nameEN || item.name || item.imgUrl || 'location'
    return `location-${base}-${index}`
  }

  return `title-${item}-${index}`
}

const ContentGrid = ({ activeView, data, language }) => {
  return (
    <div className="content-grid">
      {activeView === 'cards' &&
        data.map((item, index) => (
          <Card key={getItemKey(activeView, item, index)} item={item} language={language} />
        ))}

      {activeView === 'locations' &&
        data.map((item, index) => (
          <Location key={getItemKey(activeView, item, index)} item={item} language={language} />
        ))}

      {activeView === 'titles' &&
        data.map((item, index) => (
          <Title key={getItemKey(activeView, item, index)} title={item} />
        ))}
    </div>
  )
}

export default ContentGrid
